
// 角色权限弹框
import React, { Component } from 'react';
import { message, Modal, Form, Input, Button, Table, Popconfirm, Select } from 'antd';
import '../../../static/css/index.css'
import { getJobList, deleteJob } from '../../../apis/api'

import AddJob from './addJob'
import JobUser from './jobUser'

const { Option } = Select;

class RoleUser extends Component {
  constructor(props) {
    super(props);
    this.state={
        access_token:'',
        flag:false,
        search_params:{},
        roleJobList:[],
        currentPage:1,
        currentPageSize:10,
        total:0,
        add_job_visible:false,//按岗位授权modal是否打开
        job_user_visible:false,//查看员工信息modal是否打开
    }
  }

  componentDidMount(){
    
    this.setState({access_token:sessionStorage.getItem('access_token')},()=>{
        if(this.props.visible&&this.props.role_uuid){
            this.getJobList(null,this.props.role_uuid);
        }

    })

  }

  
  componentWillReceiveProps(nextProps) { 

    if(nextProps.visible&&this.props.visible!==nextProps.visible&&nextProps.role_uuid){
        this.getJobList(null,nextProps.role_uuid);
    }

  }

  getJobList(obj,role_uuid){
    let _this=this;
    this.setState({flag:true})
    const { access_token, currentPage, currentPageSize } = this.state;
    let params={
        access_token:access_token,
        role_uuid:role_uuid?role_uuid:_this.props.role_uuid,
        level:obj&&obj.level?obj.level:'',
        job_type:obj&&obj.job_type?obj.job_type:'',
        page:currentPage,
        page_size:currentPageSize
    }
  
    getJobList(params).then( (data)=> {

        if(data.code === 0){
            
            let roleJobList=data.content.list;
            let total=data.content.paging.total_record;
            _this.setState({ roleJobList, total, flag:false })

        }else{

            message.error(data.message); 
        }
    });

  }

    //按岗位授权
    addJob = ()=>{
        this.setState({
            add_job_visible:true,
        });
    }

    jobDetail = (record)=>{
        this.setState({
            job_user_visible:true,
            details:record
        });
    }
    
    // 删除员工
    deleteJob(record){
        let _this=this;
        let params={
          access_token:_this.state.access_token,
          level:record.level,
          job_type:record.job_type,
          role_uuid:_this.props.role_uuid
        }
        deleteJob(params).then( (data)=> {
          if(data.code===0){
            message.success('删除岗位成功！');
            _this.setState({currentPage:1},()=>{
                _this.getJobList(_this.state.search_params);
            })
          }else{
            message.error(data.message);
          }
        });
    }

    // 关闭弹窗
    handleCancel = (e) => {
        this.setState({
            add_job_visible:false,
            job_user_visible:false,
        });
    }   

  //页码变化
  handleTableChange = pagination => {
    var _this = this;
    const current = pagination.current || 1;
    this.setState({ currentPage: current },()=>{
        _this.getJobList(_this.state.search_params);
    });
  }
  
  //搜索
  searchJob = () =>{
    let _this=this;
    _this.props.form.validateFields((err, values) => {
      if(err) {
          console.log('submit error:' ,err);
      }else {
        _this.setState({currentPage:1,search_params:values},()=>{
            _this.getJobList(values);
        })
      }
    });
  }

  // 点击确定、取消按钮
  handleOk = (e) => {
    this.setState({
        currentPage:1,
        currentPageSize:10,
        total:0
    },()=>{
        this.props.cancelModal();
        this.props.form.resetFields();
    })
  }

  
  render() {
    const { getFieldDecorator } = this.props.form;
    const { visible, role_uuid, role_name } = this.props;
    const { currentPage, curPageSize, total, roleJobList, flag, add_job_visible, job_user_visible, details } = this.state;

    const columns=[{
        title: '角色名称',
        dataIndex: 'role_name',
        width:'25%',
        align:'center',
      },{
        title: '层级',
        dataIndex: 'level',
        width:'20%',
        align:'center',
        render:(text, record, index) => <span>
            {text===1?'总部':''}
            {text===2?'区域':''}
            {text===3?'城市':''}
            {text===4?'项目':''}
        </span>
      },{
        title: '岗位名称',
        dataIndex: 'job_type',
        width:'25%',
        align:'center',
        },{
        title: '操作',
        dataIndex: 'operation',
        width:'30%',
        align:'center',
        render:(text, record,index) => (<div style={{display:'flex',justifyContent:'center'}}>
           <p><a style={{marginRight:10}} onClick={this.jobDetail.bind(this,record)}>查看员工</a></p>
           <p>
             <Popconfirm title="确认删除该岗位吗?" okText="确认" cancelText="取消" onConfirm={()=>this.deleteJob(record)} onCancel={()=>{}}>
                 <a>删除</a>
             </Popconfirm>
           </p>
        </div>)
    }];

    return (

       <div className='role_user_form'>
         <Modal
            title="授权"
            visible={visible}
            onCancel={this.handleOk}
            footer={null}
            width={'80%'}
         >
       
          <div className='search_form'>
            <Form layout="inline">
                <Form.Item label="层级">
                    {getFieldDecorator('level', {
                        initialValue:undefined
                    })(
                        <Select allowClear placeholder='请选择层级' style={{width:200}}>
                            <Option key={1} value={1}>总部</Option>
                            <Option key={2} value={2}>区域</Option>
                            <Option key={3} value={3}>城市</Option>
                            <Option key={4} value={4}>项目</Option>
                        </Select>
                    )}
                </Form.Item>

                <Form.Item label="岗位名称">
                    {getFieldDecorator('job_type', {
                        initialValue:''
                    })(
                        <Input placeholder='请输入岗位名称' style={{width:200}} onPressEnter={this.searchJob} />
                    )}
                </Form.Item>

                <Form.Item>
                   <Button type='primary' onClick={this.searchJob}>搜索</Button>
                </Form.Item>

            </Form>
          </div>

          <div className="add_btn">
              <Button type="primary" onClick={this.addJob}>按岗位授权</Button>
          </div>

          <div className="layout_content_table">
                <Table rowKey='id' scroll={{ y: 400 }} columns={columns} dataSource={roleJobList} loading={flag} 
                       pagination={{
                            current: currentPage,
                            pageSize: curPageSize,
                            total: total
                       }}
                        onChange={this.handleTableChange}/>
          </div>

         
          <AddJob visible={add_job_visible} role_uuid={role_uuid} role_name={role_name} cancelModal={this.handleCancel} getJobList={this.searchJob}/>
    
          <JobUser visible={job_user_visible} role_uuid={role_uuid} details={details} cancelModal={this.handleCancel}/>

         </Modal>

       </div>
    );
  }
}

RoleUser = Form.create({
   
})(RoleUser);
export default RoleUser;



// WEBPACK FOOTER //
// ./src/page/Privilege/components/roleJob.js